import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const MailingPassFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='CONTRASENA' htmlFor='input-mailingPass' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='mailingPass'>
          {({ field }) => <Form.InputPassword {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='input-mailingPass' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MailingPassFormGroup)
